import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/thumbs-up.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M13.1911 4.80828C13.1911 4.07196 12.6222 3.46995 11.9 3.41468L8.58802 10.8665C8.54055 10.9732 8.48279 11.0733 8.41836 11.1676V20.5909H17.4157C18.358 20.5909 19.1601 19.903 19.3033 18.9717L20.3306 12.2899C20.5083 11.1336 19.6138 10.0909 18.4439 10.0909H15.1002C14.0458 10.0909 13.1911 9.23618 13.1911 8.18182V4.80828ZM3.64563 19.6364C3.64563 20.1635 4.073 20.5909 4.60018 20.5909H6.50927V12H4.60018C4.073 12 3.64563 12.4274 3.64563 12.9545V19.6364ZM15.1002 8.18182H18.4439C20.784 8.18182 22.5741 10.2678 22.2183 12.5807L21.1901 19.2626C20.9035 21.1251 19.3002 22.5 17.4157 22.5H4.60018C3.01864 22.5 1.73654 21.2179 1.73654 19.6364V12.9545C1.73654 11.373 3.01864 10.0909 4.60018 10.0909H6.84392L10.2025 2.53285L10.2585 2.41726C10.5594 1.85538 11.1476 1.5 11.7919 1.5L11.9625 1.50466C13.7103 1.59346 15.1002 3.03839 15.1002 4.80828V8.18182Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ThumbsUpIcon };
